import { PropertyType } from 'esa-ui-library/lib/types';
import { OptionType, TableHeaderType } from '../../../common';
import { reportConstants } from '../../constants/reports';
import { isEmpty } from 'lodash';

export const filterFieldsByEnv = (fields: TableHeaderType[]): TableHeaderType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.label !== reportConstants.REPORT_PGDA_831);
	}

	return result;
};

export const filterSearchOptionsByEnv = (fields: OptionType[]): OptionType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.value !== 'aams_game_ids');
	}

	return result;
};

export const getErrorMessage = (field: string): string => `${field} is required`;

export const validateForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.game_provider_name) {
		errors.game_provider_name = getErrorMessage('Game provider name');
	}

	if (!form.game_provider_id) {
		errors.game_provider_id = getErrorMessage('Game provider id');
	}

	if (!form.provider_url_live_desktop) {
		errors.provider_url_live_desktop = getErrorMessage('Provider url live desktop');
	}

	if (!form.provider_url_test_desktop) {
		errors.provider_url_test_desktop = getErrorMessage('Provider url test desktop');
	}

	if (!form.provider_url_live_mobile) {
		errors.provider_url_live_mobile = getErrorMessage('Provider url live mobile');
	}

	if (!form.provider_url_test_mobile) {
		errors.provider_url_test_mobile = getErrorMessage('Provider url test mobile');
	}

	if (!form.history_url_live) {
		errors.history_url_live = getErrorMessage('History url live');
	}

	if (!form.history_url_test) {
		errors.history_url_test = getErrorMessage('History url test');
	}

	return !isEmpty(errors) ? errors : null;
};

export const validateProvidersForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.short_name_test) {
		errors.short_name_test = getErrorMessage('Short name test');
	}

	if (!form.short_name_live) {
		errors.short_name_live = getErrorMessage('Short name live');
	}

	return !isEmpty(errors) ? errors : null;
};
